module.exports = __webpack_public_path__ + "img/logo-propias.2b9adc17.png";